const countries = Object.freeze([
  {value: 'CA', text: 'Canada'},
  {value: 'US', text: 'United States'},
  {value: 'BM', text: 'Bermuda'},
]);

export default countries;
